import request from '@/utils/request'

// 获取文件列表（适配java110框架）
export function getFileList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/fileManage.QueryFileManageCmd",
      method: "get",
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传文件（保存文件信息）
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/fileManage.SaveFileManageCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除单个文件
export function deleteFile(fileId) {
  return new Promise((resolve, reject) => {
    request({
      url: "/fileManage.DeleteFileManageCmd",
      method: "post",
      data: { id: fileId }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量删除文件
export function batchDeleteFile(fileIds) {
  return new Promise((resolve, reject) => {
    request({
      url: "/fileManage.DeleteFileManageCmd",
      method: "post",
      data: { ids: fileIds }
    }).then(response => {
      const res = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 下载文件
export function downloadFile(fileId) {
  return new Promise((resolve, reject) => {
    request({
      url: "/fileManage.DownloadFileManage",
      method: "post",
      data: { id: fileId },
      responseType: 'blob'
    }).then(response => {
      resolve(response) // 下载接口直接返回response，不解析data
    }).catch(error => {
      reject(error)
    })
  })
}
